import { createAppRequest } from '@/services/request';
import type { ApiResponse } from './types/common';
import type {
  CreateDictionaryItemPayload,
  DictionaryCatalogItem,
  DictionaryItem,
  UpdateDictionaryItemPayload,
} from './types/dictionary';

const request = createAppRequest();

const unwrap = <T>(response: ApiResponse<T>) => response.data;

export async function queryDictionaryCatalog() {
  const response = await request<ApiResponse<DictionaryCatalogItem[]>>('/bff/dictionaries/catalog', {
    method: 'GET',
  });
  return unwrap(response);
}

export async function queryDictionaryItems(dictionaryCode: string) {
  const response = await request<ApiResponse<DictionaryItem[]>>(`/bff/dictionaries/${dictionaryCode}/items`, {
    method: 'GET',
  });
  return unwrap(response);
}

export async function createDictionaryItem(
  dictionaryCode: string,
  payload: CreateDictionaryItemPayload,
) {
  const response = await request<ApiResponse<DictionaryItem>>(`/bff/dictionaries/${dictionaryCode}/items`, {
    method: 'POST',
    data: payload,
  });
  return unwrap(response);
}

export async function updateDictionaryItem(
  dictionaryCode: string,
  itemUuid: string,
  payload: UpdateDictionaryItemPayload,
) {
  const response = await request<ApiResponse<DictionaryItem>>(`/bff/dictionaries/${dictionaryCode}/items/${itemUuid}`, {
    method: 'PATCH',
    data: payload,
  });
  return unwrap(response);
}

export async function deleteDictionaryItem(dictionaryCode: string, itemUuid: string) {
  const response = await request<ApiResponse<true>>(`/bff/dictionaries/${dictionaryCode}/items/${itemUuid}`, {
    method: 'DELETE',
  });
  return { success: unwrap(response) };
}
